import { render, staticRenderFns } from "./CardOrderStatusFilter.vue?vue&type=template&id=6f8a75b7&"
import script from "./CardOrderStatusFilter.vue?vue&type=script&lang=js&"
export * from "./CardOrderStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports